import { FormControl, FormGroup } from "@angular/forms";

export type LandAreaFormGroup = FormGroup<{
  planning_status_id: FormControl<number>,
  qos_degradation_id: FormControl<number>,
  env_considerations: FormControl<string>,
  other_considerations: FormControl<string>,
  zoning_comment: FormControl<string>,
  zoning_file_name: FormControl<string>,
  zoning_file_path: FormControl<string>,
  zoning_file_display_name: FormControl<string>,
  heritage_file_name: FormControl<string>,
  heritage_file_path: FormControl<string>,
  heritage_comment: FormControl<string>,
  heritage_file_display_name: FormControl<string>
}>

export function createLandAreaFormGroup(payload: {
  planningStatusId: number,
  qosDegradationId: number,
  envConsiderations: string,
  otherConsiderations: string,
  zoning_file_name: string,
  zoning_file_path: string,
  zoning_comment: string,
  heritage_file_name: string,
  heritage_file_path: string,
  heritage_comment: string,
}): LandAreaFormGroup {
  return new FormGroup({
    planning_status_id: new FormControl<number>(payload.planningStatusId),
    qos_degradation_id: new FormControl<number>(payload.qosDegradationId),
    env_considerations: new FormControl<string>(payload.envConsiderations),
    other_considerations: new FormControl<string>(payload.otherConsiderations),
    zoning_file_name: new FormControl<string>(payload.zoning_file_name),
    zoning_file_path: new FormControl<string>(payload.zoning_file_path),
    zoning_comment: new FormControl<string>(payload.zoning_comment),
    heritage_file_name: new FormControl<string>(payload.heritage_file_name),
    heritage_file_path: new FormControl<string>(payload.heritage_file_path),
    heritage_comment: new FormControl<string>(payload.heritage_comment),
    zoning_file_display_name: new FormControl<string>(normalizeName(payload.zoning_file_name)),
    heritage_file_display_name: new FormControl<string>(normalizeName(payload.heritage_file_name))
  })
}

export function normalizeName(text: string): string {
  if (!text) return null
  return text.replace(/^\d+_/, '')
}